module Meevo.Plugins.ClientPoint {

    export abstract class ClientPointSectionBase<T> extends Meevo.Components.BaseClasses.DataMaintenanceSectionBase<T> {

        constructor(
            sectionId: number,
            displayNameContentKey: string,
            template: string,
            isPrimarySection: boolean,
            handlesOwnCrud: boolean,
            baseEndpoint: string,
            sectionEndpoint: string,
            loggingService: Meevo.Components.Logging.ILoggingService,
            dataService: Meevo.Components.BaseClasses.IDataService,
            identityService: Meevo.Components.Common.IIdentityService,
            noun: Meevo.Model.NounEnum,
            private $rootScope: angular.IRootScopeService,
            protected context: Meevo.Plugins.ClientPoint.ClientPointContext,
            sectionSecurityKey?: string) {
                
            super(sectionId, displayNameContentKey, template, isPrimarySection, handlesOwnCrud, baseEndpoint, sectionEndpoint, loggingService, dataService, identityService, noun,null,sectionSecurityKey);
        }

        public headerContentAction = ($event): void => {
            this.$rootScope.$broadcast(Meevo.Components.Common.Messages.GOTO_STATE, {
                stateName: this.context.appSettings.ROUTE_NAMES.client,
                stateParams: {
                  callback: null,
                  callbackState: null,
                  targetState: Meevo.Model.MaintenanceFormVisualState.Detail,
                  actionState: Meevo.Model.MaintenanceFormState.Readonly,
                  initialEditSection: "SECTION_MAIN",
                  clientDisplayName: this.context.clientDisplayName,
                  id: this.context.itemId
                },
            });
            $event.stopPropagation();
        }
    }
}